import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-alert-icon',
},
  __name: 'alert-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle({ fill: __props.fill }),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 30.184 24.959"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("path", { d: "M29.796 22.442L16.679 1.059c-.873-1.425-2.301-1.405-3.174.02L.388 22.433c-.873 1.426-.221 2.527 1.449 2.527h26.509c1.671 0 2.323-1.094 1.45-2.518zM15.081 5.792c.84 0 1.49.928 1.447 2.062l-.266 6.834c-.043 1.133-.576 2.061-1.184 2.061s-1.142-.928-1.185-2.061l-.263-6.834c-.043-1.134.609-2.062 1.451-2.062zm0 16.105c-1.06 0-1.787-.775-1.765-1.834 0-1.082.729-1.834 1.765-1.834 1.08 0 1.763.752 1.786 1.834 0 1.059-.706 1.834-1.786 1.834z" }, null, -1)
    ]), 4))
  ]))
}
}

})